const SetupMoneyManagement = (() => {
  let accountClassTable, payeeListTable;

  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [
      ...formInstance.form.querySelectorAll(`
      input:invalid,
      select:invalid,
      textarea:invalid
    `),
    ];

    const isFormValid = Array.from(invalidElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  // Account Classes
  //-------------------------------------------------------------------------------
  function checkForExistingAccount(newAccountClass) {
    let existingAccountClass = false;

    moneyManagementPreferencesData.accountClasses.forEach(ac => {
      if (ac.accountClass === newAccountClass) {
        existingAccountClass = true;
      }
    });

    return existingAccountClass;
  }
  //
  function handleAccountDelete(account) {
    if (account.isFinancialAccountClass) {
      showUnableToDeletePopup('This class cannot be deleted, because it is being used on an account.');
      return;
    }

    showDeleteConfirmationPopup('Are you sure you want to delete this account class?', async deleteRecord => {
      if (deleteRecord) {
        const resp = (
          await _UTIL.fetchData('deleteAccountClass', {
            accountClass: account.accountClass,
          })
        ).deleteAccountClassResult;

        moneyManagementPreferencesData.accountClasses = moneyManagementPreferencesData.accountClasses.filter(acc => {
          if (acc.accountClass === account.accountClass) return false;
          return true;
        });
        updateAccountClassTable();
      }
    });
  }
  function updateLocalAcountData(data, oldData) {
    let existingAccount = moneyManagementPreferencesData.accountClasses.find(account => {
      if (account.accountClass === oldData.accountClass) return true;
      return false;
    });

    if (existingAccount) {
      existingAccount.accountClass = data.accountClass;
      existingAccount.isFinancialAccountClass = data.isFinancialAccountClass;
    } else {
      moneyManagementPreferencesData.accountClasses.push({
        accountClass: data.accountClass,
        isFinancialAccountClass: data.isFinancialAccountClass,
      });
    }
  }
  function showAccountClassPopup(data = {}) {
    const insertOrUpdate = Object.keys(data).length === 0 ? 'I' : 'U';

    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const accountForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Class',
          id: 'class',
          required: true,
          value: data.accountClass || '',
        },
      ],
    });

    accountForm.onKeyup(() => {
      checkForRequiredFields(accountForm);
    });
    accountForm.onChange(event => {
      if (event.target.name === 'class') {
        if (insertOrUpdate === 'U') {
          if (event.target.value === data.accountClass) {
            accountForm.inputs['class'].setValidtyError('');
            accountForm.inputs['class'].clearErrorOrWarning();
            return;
          }
        }

        const payeeAlreadyExists = checkForExistingAccount(event.target.value);

        if (payeeAlreadyExists) {
          accountForm.inputs['class'].setValidtyError('This account class already exists.');
          accountForm.inputs['class'].showError('This account class already exists.');
          accountForm.buttons['submit'].toggleDisabled(true);
        } else {
          accountForm.inputs['class'].setValidtyError('');
          accountForm.inputs['class'].clearErrorOrWarning();
          accountForm.buttons['submit'].toggleDisabled(false);
        }
      }

      checkForRequiredFields(accountForm);
    });
    accountForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertAccountClass', {
          accountClass: formdata.class,
          oldAccountClass: data.accountClass,
          insertOrUpdate: Object.keys(data).length === 0 ? 'I' : 'U',
        })
      ).InsertAccountClassResult;

      POPUP.hide(popup);

      if (resp) {
        successfulSave.show('Saved');
        setTimeout(function () {
          successfulSave.hide(true);
          updateLocalAcountData(resp, data);
          updateAccountClassTable();
        }, 1000);
      }
    });
    accountForm.onCancel(() => {
      POPUP.hide(popup);
    });

    accountForm.renderTo(popup);

    POPUP.show(popup);

    accountForm.buttons['submit'].toggleDisabled(true);

    if (insertOrUpdate === 'U' && !$.session.SetupUpdate) {
      accountForm.disableFormInputs();
    }
  }
  // table view
  function updateAccountClassTable() {
    const tableData = moneyManagementPreferencesData.accountClasses
      .sort((a, b) => a.accountClass.localeCompare(b.accountClass))
      .map(account => {
        return {
          values: [account.accountClass],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showAccountClassPopup(account);
          },
          endIconCallback: () => handleAccountDelete(account),
        };
      });

    table.populate(accountClassTable, tableData);
  }
  function getAccountClassView() {
    const frag = document.createDocumentFragment();

    accountClassTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Account Class'],
      endIcon: true,
    });

    const headers = accountClassTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addAccountClassBtn = new Button({
      text: 'Add New Account Class',
      style: 'primary',
      styleType: 'outlined',
      icon: 'add',
      class: ['addNewAccountBtn'],
    });
    addAccountClassBtn.onClick(e => {
      showAccountClassPopup();
    });

    frag.append(accountClassTable);
    if ($.session.SetupInsert) {
      addAccountClassBtn.renderTo(frag);
    }

    const tableData = moneyManagementPreferencesData.accountClasses
      .sort((a, b) => a.accountClass.localeCompare(b.accountClass))
      .map(account => {
        return {
          values: [account.accountClass],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showAccountClassPopup(account);
          },
          endIconCallback: () => handleAccountDelete(account),
        };
      });

    table.populate(accountClassTable, tableData);
    table.sortTableByHeader(accountClassTable);

    return frag;
  }

  // Payees
  //-------------------------------------------------------------------------------
  function getCategoryDropdownData() {
    const dropdownData = payeesDropdownData.Categories.reduce((acc, c) => {
      if (!acc.has(c.category)) {
        acc.set(c.category, {
          text: c.category,
          value: c.category,
          'data-type': c.categoryType,
        });
      }

      return acc;
    }, new Map());

    return Array.from(dropdownData.values());
  }
  function getSubCategoryDropdownData(selectedCategoryString) {
    const dropdownData = payeesDropdownData.Categories.reduce((acc, category) => {
      if (category.category === selectedCategoryString) {
        acc.push({
          text: category.subCategory,
          value: category.categoryId,
        });
      }

      return acc;
    }, []);

    return dropdownData;
  }
  function getRegionDropdownData() {
    const dropdownData = payeesDropdownData.Regions.map(reg => {
      return {
        text: reg.region,
        value: reg.regionId,
      };
    });

    return dropdownData;
  }
  function checkForExistingPayee(newPayee, newRegionId) {
    let existingPayee = false;

    moneyManagementPreferencesData.payees.forEach(payee => {
      if (payee.payee === newPayee && payee.regionId === parseInt(newRegionId)) {
        existingPayee = true;
      }
    });

    return existingPayee;
  }
  //
  async function handlePayeeDelete(p) {
    if (!$.session.SetupDelete) return;

    if (p.isAccountRegister) {
      showUnableToDeletePopup('This payee cannot be deleted, because it has been used on an existing transaction.');
      return;
    }

    showDeleteConfirmationPopup('Are you sure you want to delete this payee?', async deleteRecord => {
      if (deleteRecord) {
        const resp = (
          await _UTIL.fetchData('deleteSetupPagePayee', {
            payee: p.payee,
            region: p.regionId,
            category: p.categoryId,
            city: p.city,
          })
        ).deletePayeeResult;

        moneyManagementPreferencesData.payees = moneyManagementPreferencesData.payees.filter(payee => {
          if (payee.payee === p.payee && payee.regionId === p.regionId) return false;
          return true;
        });
        updatePayeeListTable();
      }
    });
  }
  function updateLocalPayeeData(data, oldData) {
    let existingPayee = moneyManagementPreferencesData.payees.find(payee => {
      if (payee.payee === oldData.payee && payee.regionId === oldData.regionId) return true;
      return false;
    });

    if (existingPayee) {
      existingPayee.payee = data.payee;
      existingPayee.region = data.region;
      existingPayee.regionId = data.regionId;
      existingPayee.address1 = data.address1;
      existingPayee.address2 = data.address2;
      existingPayee.city = data.city;
      existingPayee.state = data.state;
      existingPayee.zip = data.zip;
      existingPayee.category = data.category;
      existingPayee.categoryId = data.categoryId;
      existingPayee.subCategory = data.subCategory;
      existingPayee.subCategoryId = data.categoryId;
      existingPayee.isAccountRegister = data.isAccountRegister;
    } else {
      moneyManagementPreferencesData.payees.push({
        payee: data.payee,
        region: data.region,
        regionId: data.regionId,
        address1: data.address1,
        address2: data.address2,
        city: data.city,
        state: data.state,
        zip: data.zip,
        category: data.category,
        categoryId: data.categoryId,
        subCategory: data.subCategory,
        subCategoryId: data.categoryId,
        isAccountRegister: data.isAccountRegister,
      });
    }
  }
  function showPayeeListPopup(data = {}) {
    const insertOrUpdate = Object.keys(data).length === 0 ? 'I' : 'U';

    const categoryData = getCategoryDropdownData();
    const regionData = getRegionDropdownData();

    const popup = POPUP.build({
      classNames: 'payeeListPopup',
      hideX: true,
    });

    const payeeForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Payee',
          id: 'payee',
          required: true,
          value: data.payee,
        },
        {
          type: 'select',
          label: 'Region',
          id: 'region',
          required: true,
          data: regionData,
          value: data.regionId ? `${data.regionId}` : `${moneyManagementPreferencesData.assignedRegionId}`,
          includeBlankOption: true,
        },
        {
          type: 'text',
          label: 'Address 1',
          id: 'addressOne',
          value: data.address1,
        },
        {
          type: 'text',
          label: 'Address 2',
          id: 'addressTwo',
          value: data.address2,
        },
        {
          type: 'text',
          label: 'City',
          id: 'city',
          value: data.city,
        },
        {
          type: 'text',
          label: 'State',
          id: 'state',
          value: data.state,
          maxlength: 2,
        },
        {
          type: 'text',
          label: 'Zip',
          id: 'zip',
          value: data.zip,
        },
        {
          type: 'select',
          label: 'Category',
          id: 'category',
          data: categoryData,
          value: data.category ? `${data.category}` : '',
          includeBlankOption: true,
        },
        {
          type: 'select',
          label: 'Subcategory',
          id: 'subcategory',
          data: data.subCategory ? getSubCategoryDropdownData(data.category) : [],
          value: data.subCategory ? `${data.categoryId}` : '',
          includeBlankOption: false,
        },
      ],
    });

    payeeForm.onChange(event => {
      if (event.target.name === 'payee') {
        if (insertOrUpdate === 'U') {
          if (event.target.value === data.payee && payeeForm.inputs['region'].getValue() === data.regionId) {
            payeeForm.inputs['payee'].setValidtyError('');
            payeeForm.inputs['payee'].clearErrorOrWarning();
            return;
          }
        }

        const payeeAlreadyExists = checkForExistingPayee(event.target.value, payeeForm.inputs['region'].getValue());

        if (payeeAlreadyExists) {
          payeeForm.inputs['payee'].setValidtyError('A payee with this name and region already exists.');
          payeeForm.inputs['payee'].showError('A payee with this name and region already exists.');
          payeeForm.buttons['submit'].toggleDisabled(true);
        } else {
          payeeForm.inputs['payee'].setValidtyError('');
          payeeForm.inputs['payee'].clearErrorOrWarning();
          payeeForm.buttons['submit'].toggleDisabled(false);
        }
      }

      if (event.target.name === 'region') {
        const selectedOption = event.target.options[event.target.selectedIndex];

        if (insertOrUpdate === 'U') {
          if (selectedOption.value === data.regionId && payeeForm.inputs['payee'].getValue() === data.payee) {
            payeeForm.inputs['payee'].setValidtyError('');
            payeeForm.inputs['payee'].clearErrorOrWarning();
            return;
          }
        }

        const payeeAlreadyExists = checkForExistingPayee(payeeForm.inputs['payee'].getValue(), selectedOption.value);

        if (payeeAlreadyExists) {
          payeeForm.inputs['payee'].setValidtyError('A payee with this name and region already exists.');
          payeeForm.inputs['payee'].showError('A payee with this name and region already exists.');
          payeeForm.buttons['submit'].toggleDisabled(true);
        } else {
          payeeForm.inputs['payee'].setValidtyError('');
          payeeForm.inputs['payee'].clearErrorOrWarning();
          payeeForm.buttons['submit'].toggleDisabled(false);
        }
      }

      if (event.target.name === 'category') {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const subCategoryData = getSubCategoryDropdownData(selectedOption.value);
        payeeForm.inputs['subcategory'].populate(subCategoryData, '');
      }

      checkForRequiredFields(payeeForm);
    });
    payeeForm.onKeyup(() => {
      checkForRequiredFields(payeeForm);
    });
    payeeForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertSetupPagePayee', {
          userId: $.session.UserId,
          description: formdata.payee,
          oldDescription: data.payee,
          regionId: formdata.region,
          oldRegionId: data.regionId ? `${data.regionId}` : '',
          address1: formdata.addressOne,
          address2: formdata.addressTwo,
          city: formdata.city,
          state: formdata.state,
          zip: formdata.zip,
          categoryId: formdata.subcategory,
          insertOrUpdate: insertOrUpdate,
        })
      ).InsertPayeeResult;

      POPUP.hide(popup);

      if (resp) {
        successfulSave.show('Saved');
        setTimeout(function () {
          successfulSave.hide(true);
          updateLocalPayeeData(resp, data);
          updatePayeeListTable();
        }, 1000);
      }
    });
    payeeForm.onCancel(() => {
      POPUP.hide(popup);
    });

    payeeForm.renderTo(popup);

    POPUP.show(popup);

    payeeForm.buttons['submit'].toggleDisabled(true);

    if (insertOrUpdate === 'U' && !$.session.SetupUpdate) {
      payeeForm.disableFormInputs();
    }
  }
  // table view
  function getCategorySubCategoryString(category, subCategory) {
    if (!category) return '';
    if (!subCategory) return category;
    return `${category}: ${subCategory}`;
  }
  function updatePayeeListTable() {
    const tableData = moneyManagementPreferencesData.payees
      .sort((a, b) => a.payee.localeCompare(b.payee))
      .map(p => {
        return {
          values: [p.payee, p.region, getCategorySubCategoryString(p.category, p.subCategory), p.city],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showPayeeListPopup(p);
          },
          endIconCallback: () => handlePayeeDelete(p),
        };
      });

    table.populate(payeeListTable, tableData);
  }
  function getPayeeListView() {
    const frag = document.createDocumentFragment();

    payeeListTable = table.build({
      tableId: 'payeeListTable',
      columnHeadings: ['Payee', 'Region', 'Category', 'City'],
      endIcon: true,
    });

    const headers = payeeListTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');
    headers[1].setAttribute('data-type', 'string');
    headers[2].setAttribute('data-type', 'string');
    headers[3].setAttribute('data-type', 'string');

    const addPayeeBtn = new Button({
      text: 'Add New Payee',
      style: 'primary',
      styleType: 'outlined',
      icon: 'add',
      class: ['addNewPayeeBtn'],
    });
    addPayeeBtn.onClick(e => {
      showPayeeListPopup();
    });

    frag.append(payeeListTable);
    if ($.session.SetupInsert) {
      addPayeeBtn.renderTo(frag);
    }

    const tableData = moneyManagementPreferencesData.payees
      .sort((a, b) => a.payee.localeCompare(b.payee))
      .map(p => {
        return {
          values: [p.payee, p.region, getCategorySubCategoryString(p.category, p.subCategory), p.city],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showPayeeListPopup(p);
          },
          endIconCallback: () => handlePayeeDelete(p),
        };
      });

    table.populate(payeeListTable, tableData);
    table.sortTableByHeader(payeeListTable);

    return frag;
  }

  // Main
  //-------------------------------------------------------------------------------
  function getView(viewName) {
    const viewFragment = document.createDocumentFragment();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = `${viewName}`;

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Account Classes') {
      viewMarkup = getAccountClassView();
    }
    if (viewName === 'Payees') {
      viewMarkup = getPayeeListView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }
  function init(data, dropdownData) {
    moneyManagementPreferencesData = data;
    payeesDropdownData = dropdownData.payeesDropdownData;
  }

  return {
    init,
    getView,
  };
})();
